import React, { useState } from 'react';

import { AccountRegistrationFormValues } from 'interfaces/registration';

import AccountRegistrationPage from './AccountRegistrationPage';
import EmailRegistration from './EmailRegistration';

const AccountRegistration: React.FC = () => {
  const [formValues, setFormValues] = useState<AccountRegistrationFormValues>({
    password: '',
    password_confirmation: '',
    last_name: '',
    first_name: '',
    last_name_kana: '',
    first_name_kana: '',
    email: '',
    code: '',
  });

  // const [isConfirm, setConfirm] = useState<boolean>(false);

  const onSubmit = (formValues: AccountRegistrationFormValues) => {
    setFormValues(formValues);
    // NOTE: 確認画面遷移に使用するため一旦コメントアウト
    // setConfirm(true);
  };

  const [showEmailRegistration, setShowEmailRegistration] = useState(false);

  const handleShowEmailRegistration = () => {
    setShowEmailRegistration(true);
  };

  return showEmailRegistration ? (
    <EmailRegistration />
  ) : (
    <AccountRegistrationPage
      onSubmit={onSubmit}
      onShowEmailRegistration={handleShowEmailRegistration}
      formValues={formValues}
    />
  );
};

export default AccountRegistration;
